<div class="pergunta-modal__overlay" (click)="onFechar()">
  <div
    class="pergunta-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="pergunta-modal-title"
    data-testid="pergunta-modal"
    [formGroup]="perguntaGroup()"
    (click)="$event.stopPropagation()"
  >
    <div class="pergunta-modal__header">
      <h2 id="pergunta-modal-title" class="pergunta-modal__title">
        {{ titulo() }} — Pergunta {{ indice() + 1 }}
      </h2>
      <button
        type="button"
        class="pergunta-modal__close"
        aria-label="Fechar"
        (click)="onFechar()"
        data-testid="pergunta-modal-close"
      >
        ×
      </button>
    </div>

    <div class="pergunta-modal__fields">
      <div class="pergunta-modal__col">
        <label class="campanha-form-label">Enunciado</label>
        <input
          type="text"
          class="form-control campanha-form-control"
          formControlName="texto"
          [readOnly]="somenteLeitura()"
          data-testid="pergunta-modal-texto"
        />
      </div>
      <!-- Removido por decisão do PO — peso removido, ver plano
           2026-08-11-questionario-erro-exclusao-e-remove-peso.
      <div class="pergunta-modal__col">
        <label class="campanha-form-label">Peso</label>
        <input
          type="number"
          class="form-control campanha-form-control"
          [class.is-invalid]="!!pesoIncoerenteMensagem"
          formControlName="peso"
          min="0"
          [readOnly]="somenteLeitura()"
          data-testid="pergunta-modal-peso"
        />
      </div>
      -->
    </div>
    <!-- Removido por decisão do PO — peso removido, ver plano
         2026-08-11-questionario-erro-exclusao-e-remove-peso.
    @if (pesoIncoerenteMensagem) {
      <div class="pergunta-modal__peso-error" data-testid="pergunta-modal-peso-error">
        {{ pesoIncoerenteMensagem }}
      </div>
    }
    -->

    <div class="pergunta-modal__alternativas">
      @if (somenteLeitura() && alternativaGroups.length === 0) {
        <p class="pergunta-modal__alt-empty">Nenhuma alternativa cadastrada.</p>
      } @else {
        <div
          class="pergunta-modal__alt-row pergunta-modal__alt-row--head"
          [class.pergunta-modal__alt-row--readonly]="somenteLeitura()"
        >
          <span class="questionario-col-label">Alternativa</span>
          <span class="questionario-col-label">Pontos</span>
          @if (!somenteLeitura()) {
            <span></span>
          }
        </div>

        @for (altGroup of alternativaGroups; track $index; let j = $index) {
          <div
            class="pergunta-modal__alt-row"
            [class.pergunta-modal__alt-row--readonly]="somenteLeitura()"
            [formGroup]="altGroup"
            data-testid="alternativa-modal-item"
          >
            <input
              type="text"
              class="form-control campanha-form-control"
              formControlName="texto"
              [attr.aria-label]="'Texto da alternativa ' + (j + 1)"
              [readOnly]="somenteLeitura()"
              data-testid="alternativa-modal-texto"
            />
            <div class="pergunta-modal__alt-pontos">
              <input
                type="number"
                class="form-control campanha-form-control"
                [class.is-invalid]="!!alternativaPontosErro(altGroup)"
                formControlName="pontos"
                [attr.aria-label]="'Pontos da alternativa ' + (j + 1)"
                min="0"
                max="9999"
                [readOnly]="somenteLeitura()"
                data-testid="alternativa-modal-pontos"
              />
              @if (alternativaPontosErro(altGroup)) {
                <span class="pergunta-modal__peso-error" data-testid="alternativa-modal-pontos-error">
                  {{ alternativaPontosErro(altGroup) }}
                </span>
              }
            </div>
            @if (!somenteLeitura()) {
              <button
                type="button"
                class="campanha-form-icon-btn campanha-form-icon-btn--remove"
                [attr.aria-label]="'Remover alternativa ' + (j + 1)"
                [disabled]="alternativas.length <= 2"
                (click)="removerAlternativa.emit(j)"
                data-testid="btn-remover-alternativa-modal"
              >
                −
              </button>
            }
          </div>
        }
      }

      @if (!somenteLeitura()) {
        <button
          type="button"
          class="campanha-form-icon-btn campanha-form-icon-btn--add questionario-add-btn"
          aria-label="Adicionar alternativa"
          (click)="adicionarAlternativa.emit()"
          data-testid="btn-adicionar-alternativa-modal"
        >
          +
        </button>
      }
    </div>
    @if (!somenteLeitura() && alternativasInsuficientesMensagem) {
      <div class="pergunta-modal__peso-error" data-testid="pergunta-modal-alternativas-error">
        {{ alternativasInsuficientesMensagem }}
      </div>
    }

    @if (!somenteLeitura()) {
      @if (motivoIncluirDesabilitado) {
        <div class="pergunta-modal__peso-error" data-testid="pergunta-modal-incluir-error">
          {{ motivoIncluirDesabilitado }}
        </div>
      }
      <div class="pergunta-modal__actions">
        <button
          type="button"
          class="btn-primary"
          [disabled]="!!motivoIncluirDesabilitado"
          data-testid="pergunta-modal-fechar"
          (click)="onFechar()"
        >
          Incluir
        </button>
      </div>
    }
  </div>
</div>
